/* ============================================================================
   bsfn-line.js — BSFN signature "flat line vs spike" motif primitive.
   Self-contained, no dependencies. Loaded only by sections that use it.

   Brand idea: legacy food SPIKES blood sugar; BSFN keeps the line FLAT.
   Public API (window.BSFN.line):
     hero(el, opts)        Build the animated hero viz inside el: a grey spike
                           draws in, the flat glucose line draws over it and
                           holds, a glow node tracks the cursor along the flat
                           line. Reduced-motion → static pre-drawn flat line.
     bindCart(form, opts)  Progressive-enhance an add-to-cart <form>: AJAX add,
                           cart-bubble bump, a calm flat-line pulse on the
                           button, then a 'bsfn:cart:updated' event that the
                           cart drawer picks up. Falls through to native POST on
                           any failure (never breaks commerce). Also dispatches
                           Shopify's standard shopify:cart:lines-update through
                           BSFN.std (bsfn-agent.js) — opts.stdContext sets its
                           context, 'product' by default.
   ========================================================================== */
(function () {
  /* Storefront root from Shopify (a locale or market prefix lives here), never a bare '/'. */
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  if (window.BSFN && window.BSFN.line) return;
  var BSFN = (window.BSFN = window.BSFN || {});
  var SVGNS = 'http://www.w3.org/2000/svg';
  var REDUCED = false;
  try { REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  var VW = 1000, VH = 460; // viewBox; SVG scales to container (preserveAspectRatio none)

  // --- point generators (normalized y: 0 bottom .. 1 top) ----------------
  function flatPoints(n) {
    n = n || 48; var a = [];
    for (var i = 0; i < n; i++) { var t = i / (n - 1); a.push({ x: t, y: 0.52 + Math.sin(t * 7) * 0.012 }); }
    return a;
  }
  function spikePoints(n) {
    n = n || 48; var a = [];
    for (var i = 0; i < n; i++) {
      var t = i / (n - 1), y = 0.5;
      if (t > 0.30 && t < 0.62) { var u = (t - 0.30) / 0.32; y = 0.5 + Math.sin(u * Math.PI) * 0.46; }
      else if (t >= 0.62 && t < 0.82) { y = 0.5 - ((t - 0.62) / 0.20) * 0.22; } // crash below baseline
      else if (t >= 0.82) { y = 0.28 + ((t - 0.82) / 0.18) * 0.20; }            // limp recovery
      a.push({ x: t, y: y });
    }
    return a;
  }
  // smooth path 'd' from points using Catmull-Rom → cubic bezier
  function smoothPath(pts) {
    var P = pts.map(function (p) { return { x: p.x * VW, y: (1 - p.y) * VH }; });
    var d = 'M' + P[0].x.toFixed(1) + ' ' + P[0].y.toFixed(1);
    for (var i = 0; i < P.length - 1; i++) {
      var p0 = P[i - 1] || P[i], p1 = P[i], p2 = P[i + 1], p3 = P[i + 2] || p2;
      var c1x = p1.x + (p2.x - p0.x) / 6, c1y = p1.y + (p2.y - p0.y) / 6;
      var c2x = p2.x - (p3.x - p1.x) / 6, c2y = p2.y - (p3.y - p1.y) / 6;
      d += 'C' + c1x.toFixed(1) + ' ' + c1y.toFixed(1) + ' ' + c2x.toFixed(1) + ' ' + c2y.toFixed(1) + ' ' + p2.x.toFixed(1) + ' ' + p2.y.toFixed(1);
    }
    return d;
  }
  function mk(tag, attrs) { var e = document.createElementNS(SVGNS, tag); for (var k in attrs) e.setAttribute(k, attrs[k]); return e; }

  // --- hero viz ----------------------------------------------------------
  BSFN.line = {
    hero: function (el, opts) {
      if (!el || el.__bsfnLine) return; el.__bsfnLine = true;
      opts = opts || {};
      var flatColor = opts.flatColor || '#1D9DD4';
      var spikeColor = opts.spikeColor || '#C9CCD1';
      var w = +opts.thickness || 4;

      var svg = mk('svg', { viewBox: '0 0 ' + VW + ' ' + VH, preserveAspectRatio: 'none', 'aria-hidden': 'true', focusable: 'false' });
      svg.setAttribute('style', 'position:absolute;inset:0;width:100%;height:100%;display:block;overflow:visible;pointer-events:none;z-index:0');
      var spike = mk('path', { d: smoothPath(spikePoints()), fill: 'none', stroke: spikeColor, 'stroke-width': w, 'stroke-linecap': 'round', 'stroke-linejoin': 'round', opacity: '0.55' });
      var flat = mk('path', { d: smoothPath(flatPoints()), fill: 'none', stroke: flatColor, 'stroke-width': w, 'stroke-linecap': 'round', 'stroke-linejoin': 'round' });
      var glow = mk('circle', { r: 7, fill: flatColor, opacity: '0' });
      var glowHalo = mk('circle', { r: 16, fill: flatColor, opacity: '0' });
      svg.appendChild(spike); svg.appendChild(flat); svg.appendChild(glowHalo); svg.appendChild(glow);
      el.appendChild(svg);

      if (REDUCED || opts.animate === false) { return; } // static: both lines drawn, no animation, no glow

      // draw-on via stroke-dashoffset + WAAPI
      [spike, flat].forEach(function (p) { var L = p.getTotalLength(); p.style.strokeDasharray = L; p.style.strokeDashoffset = L; });
      var sL = spike.getTotalLength(), fL = flat.getTotalLength();
      if (spike.animate) {
        spike.animate([{ strokeDashoffset: sL }, { strokeDashoffset: 0 }], { duration: 700, easing: 'cubic-bezier(.5,0,.1,1)', fill: 'forwards' });
        flat.animate([{ strokeDashoffset: fL }, { strokeDashoffset: fL }, { strokeDashoffset: 0 }], { duration: 1500, easing: 'cubic-bezier(.5,0,.1,1)', fill: 'forwards' });
      } else { spike.style.strokeDashoffset = 0; flat.style.strokeDashoffset = 0; }

      // cursor-reactive glow node tracking along the flat line
      var raf = 0, targetT = 0.5, curT = 0.5, active = false;
      function place(t) {
        var pt = flat.getPointAtLength(Math.max(0, Math.min(1, t)) * fL);
        glow.setAttribute('cx', pt.x); glow.setAttribute('cy', pt.y);
        glowHalo.setAttribute('cx', pt.x); glowHalo.setAttribute('cy', pt.y);
      }
      function loop() {
        curT += (targetT - curT) * 0.12;
        place(curT);
        if (active || Math.abs(targetT - curT) > 0.001) { raf = requestAnimationFrame(loop); } else { raf = 0; }
      }
      el.addEventListener('pointermove', function (e) {
        if (e.pointerType === 'touch') return;
        var r = el.getBoundingClientRect(); targetT = (e.clientX - r.left) / r.width;
        glow.setAttribute('opacity', '1'); glowHalo.setAttribute('opacity', '0.18');
        active = true; if (!raf) raf = requestAnimationFrame(loop);
      }, { passive: true });
      el.addEventListener('pointerleave', function () { active = false; glow.setAttribute('opacity', '0'); glowHalo.setAttribute('opacity', '0'); });
    },

    // --- cart "flatline celebration" -------------------------------------
    bindCart: function (form, opts) {
      if (!form || form.__bsfnCart) return; form.__bsfnCart = true;
      opts = opts || {};
      if (!window.fetch || !window.FormData) return; // no enhancement → native POST
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[name="add"],[type="submit"]');
        var said = btn ? btn.getAttribute('aria-label') : null;
        var fd = new FormData(form);
        var ev = BSFN.std
          ? BSFN.std.cartLines(form, 'add', opts.stdContext || 'product', [{ merchandiseId: fd.get('id'), quantity: fd.get('quantity') || 1 }])
          : { done: function () {}, fail: function () {} };
        fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function () { return fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); })
          .then(function (cart) {
            ev.done(cart);
            // update the BSFN header bubble
            var bub = document.querySelector('[data-bsfn-cart-count]');
            if (bub) { bub.textContent = cart.item_count; bub.classList.remove('is-empty'); if (!REDUCED) { bub.classList.remove('bsfn-bump'); void bub.offsetWidth; bub.classList.add('bsfn-bump'); } }
            announce(form, 'Added to cart.');
            if (!REDUCED && btn) flatPulse(btn, opts.flatColor || '#1D9DD4');
            // This event IS the theme's cart bus. bsfn-cart-drawer.js listens and
            // re-renders itself from the Section Rendering API; anything else that
            // needs to react to a cart change (the sugar widget, future
            // cart-reactive UI) listens on document rather than being wired in
            // here by hand.
            try {
              document.dispatchEvent(new CustomEvent('bsfn:cart:updated', {
                detail: { cart: cart, source: 'add' }
              }));
            } catch (e) {}
            if (typeof opts.onAdded === 'function') opts.onAdded(cart);
          })
          .catch(function (err) { ev.fail(err); form.submit(); }); // hard fallback: native add, never block commerce
      });
    }
  };

  function announce(form, msg) {
    var live = form.querySelector('[data-bsfn-live]');
    if (!live) { live = document.createElement('p'); live.setAttribute('data-bsfn-live', ''); live.setAttribute('aria-live', 'polite'); live.style.cssText = 'position:absolute;left:-9999px'; form.appendChild(live); }
    live.textContent = msg;
  }
  function flatPulse(btn, color) {
    if (getComputedStyle(btn).position === 'static') btn.style.position = 'relative';
    var ov = document.createElementNS(SVGNS, 'svg');
    ov.setAttribute('viewBox', '0 0 100 24'); ov.setAttribute('preserveAspectRatio', 'none');
    ov.setAttribute('style', 'position:absolute;inset:0;width:100%;height:100%;pointer-events:none;overflow:visible');
    var p = mk('path', { d: 'M2 12 H40 q4 0 6 -7 q2 0 4 14 q2 0 4 -7 H98', fill: 'none', stroke: color, 'stroke-width': 2, 'stroke-linecap': 'round', opacity: '0.9' });
    ov.appendChild(p); btn.appendChild(ov);
    var L = p.getTotalLength(); p.style.strokeDasharray = L; p.style.strokeDashoffset = L;
    if (p.animate) {
      p.animate([{ strokeDashoffset: L }, { strokeDashoffset: 0 }], { duration: 520, easing: 'cubic-bezier(.5,0,.1,1)' });
      ov.animate([{ opacity: 1 }, { opacity: 1, offset: 0.7 }, { opacity: 0 }], { duration: 900, fill: 'forwards' }).onfinish = function () { ov.remove(); };
    } else { setTimeout(function () { ov.remove(); }, 600); }
  }
})();
